export const TEXT_GENERAL_SKILL = "/skill_general_text"

export const handleFetchError = (text: string) => {
  return text
}

export const BACK_PAGE = -1;
